<template>
  <a-row :gutter="[16, 16]">
    <a-col
      :xs="24"
      :sm="12"
      :md="12"
      :lg="8"
      :xl="8"
      :xxl="4"
      v-for="(itm, index) in item"
      :key="index"
    >
      <a-card :loading="loading">
        <!-- <slot /> -->
        <div class="w-full bg-white flex card items-center">
          <components v-if="itm.components" :is="itm.components" class="m-r-10"/>
          <div>
            <div class="title text-12">{{ itm.title }}</div>
            <div class="count">{{ itm.num.toLocaleString() }}</div>
          </div>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'Statistics',
  props: {
    item: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
// ::v-deep .
.card {
  gap: 16px;
}
.title {
  font-size: 12px;
}
.count {
  font-size: 20px;
  font-weight: 600;
  color: #202224;
}
</style>
